module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (_vm.order.countdown == null) ? _c('div', [(!_vm.listOrderWindow) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t("orders.orderWindow.unlinkedOrderMessage")) + ".")]), _vm._v(" "), (_vm.diamAdminRights) ? _c('button', {
    staticClass: "btn btn-client selectOrderButton",
    on: {
      "click": function($event) {
        _vm.showOrderWindowList();
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t("orders.orderWindow.selectButton")) + "\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.diamAdminRights && _vm.listOrderWindow) ? _c('div', {
    staticClass: "orderWindowListBloc"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("orders.orderWindow.listeTitle")) + " :\n            "), _c('div', {
    staticClass: "orderWindowsList"
  }, [_vm._l((_vm.getCountDownNext), function(orderWindow, index) {
    return _c('div', {
      key: orderWindow.id,
      staticClass: "orderWindowItem",
      class: {
        dashed: index % 2 == 0, active: orderWindow.id == _vm.orderWindowSelected.countdown.id
      },
      on: {
        "click": function($event) {
          _vm.selectOrderWindow(orderWindow);
        }
      }
    }, [_c('h4', {
      staticClass: "orderWindowItemTitle"
    }, [_vm._v(_vm._s(orderWindow.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDate(orderWindow.startDate)) + " >>>> " + _vm._s(_vm.formatDate(orderWindow.endDate)))])])
  }), _vm._v(" "), (_vm.diamAdminRights && _vm.getCountDownNext.length > 0) ? _c('button', {
    staticClass: "btn btn-client fright",
    on: {
      "click": function($event) {
        _vm.linkOrderWindowAction();
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("orders.orderWindow.linkAction")) + "\n                ")]) : _vm._e()], 2)]) : _vm._e()]) : _c('div', [_vm._v("\n        " + _vm._s(_vm.$t("orders.orderWindow.linkedTitle")) + " :\n        "), _c('h4', {
    staticClass: "orderWindowTitle"
  }, [_vm._m(0), _vm._v(" " + _vm._s(_vm.order.countdown.name) + "\n        ")]), _vm._v(" "), (_vm.diamAdminRights) ? _c('button', {
    staticClass: "btn btn-client",
    on: {
      "click": function($event) {
        _vm.unlinkOrderWindowAction();
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("orders.orderWindow.unlinkAction")) + "\n        ")]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "roundedIcon"
  }, [_c('i', {
    staticClass: "far fa-calendar-alt fa-lg"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4773bfaf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/order-common/order-windows.vue
// module id = 3157
// module chunks = 0